const themePlugin = {
  install(Vue) {
    Object.defineProperty(Vue.prototype, '$themes', {
      get() {
        const vm = this;

        return {
          applyTheme(themeName) {
            if (!vm.$vuetify || !vm.$vuetify.theme) {
              return;
            }

            const allThemes = vm.$vuetify.theme.defaults;
            const theme = allThemes[themeName];

            if (!theme) {
              return;
            }

            const targetMode = vm.$vuetify.theme.dark ? 'dark' : 'light';

            Object.keys(theme).forEach((key) => {
              vm.$vuetify.theme.themes[targetMode][key] = theme[key];
            });

            if (themeName === 'dark') {
              vm.$vuetify.theme.dark = true;
            }
          },

          toggleDark() {
            if (!vm.$vuetify || !vm.$vuetify.theme) return;
            vm.$vuetify.theme.dark = !vm.$vuetify.theme.dark;
          },
        };
      },
    });
  },
};

export default themePlugin;
